import { Component, OnInit } from '@angular/core';
import { IUser } from 'projects/common/src/app/interfaces';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { IMachineType } from 'projects/common/src/app/interfaces/machine-type';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { IShift } from 'src/app/modules/core/interfaces';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { IResponseDrillActivity } from 'src/app/modules/widget/interfaces/drill-activity-type';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication';
import { IStoredProcedureInputs } from '../../../interfaces/chart-widget';
import { DashboardWidgetBasicComponent } from '../../dashboard-widget-basic/dashboard-widget-basic.component';

@Component({
  selector: 'app-drill-activity-type',
  templateUrl: './drill-activity-type.component.html',
  styleUrls: ['./drill-activity-type.component.scss'],
})
export class DrillActivityTypeComponent extends DashboardWidgetBasicComponent implements OnInit {
  public dataDrillActivity: IResponseDrillActivity;
  public drillDetail = [];
  public drillList = [];
  public tableConfig: ITableConfig;
  public subtitleWidget: string;
  public displayMessage: boolean;

  constructor(
    public booleanBarService: BooleanStateService,
    public communication: CommunicationService,
    public parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    private langService: LanguageService,
    private tableService: TableConfigService,
    protected screenViewService: ScreenViewService,
    private datePipe: DatePresentationPipe,
  ) {
    super(booleanBarService, communication, parameterService, cacheService, machineContext, screenViewService);
  }

  /**
   * build request params
   */
  protected buildRequestParams(): IStoredProcedureInputs {
    const companyId = String((this.parameterService.parameters.item('user-data').value as IUser).company.id);
    const shiftId = -1;
    const inputDate = String(this.parameterService.parameters.item('date').value);
    const currentMachine = (this.parameterService.parameters.item('machine-context').value as IMachineContext).name;
    const machineCollection = this.parameterService.parameters.item('machine-collection').value as IMachineType[];
    const machine = machineCollection.find((value) => String(value.name).toLowerCase() === String(currentMachine).toLowerCase());
    const { machineTypeId } = machine;
    const zone = this.cacheService.session('selectedZone').zoneId;

    return {
      inputDate,
      shiftId,
      companyId,
      machineTypeId,
      zoneId: zone,
    };
  }

  /**
   *  buildView Minute by MInute
   *
   * @param values parameter value
   */
  public buildView(values: any): void {
    super.buildView(values);
    this.getDrillActivityType(values);
  }

  /**
   *  get data drill activity type widget
   */
  public async getDrillActivityType(drillActivity: IResponseDrillActivity): Promise<any> {
    const machineType = this.parameterService.parameters.item('machine-context').value || 'no disponible';
    const date = this.parameterService.parameters.item('date').value;
    const shiftName = this.parameterService.parameters.item('shift').value as IShift;
    const user = this.parameterService.parameters.item('user-data').value;

    this.subtitleWidget = `${this.langService.message('company')}: ${user.company.name},
    ${this.langService.message('device')}: ${this.langService.message(machineType.name)},
    ${this.langService.message('date')}: ${this.datePipe.transform(date)},
    ${this.langService.message('shift_')}: ${shiftName.name}`;
    this.dataDrillActivity = drillActivity;

    const mappedActivity = [];

    if (this.dataDrillActivity.drillActivityList.length > 0 && this.dataDrillActivity.drillActivityProductionShift.length > 0) {
      this.displayMessage = false;
      let totalActivity = new Array(this.dataDrillActivity.drillActivityList.length + 1).fill(0);
      const shiftLabel = this.langService.message('shiftName');
      this.dataDrillActivity.drillActivityProductionShift.forEach((s) => {
        const obj: any = {};
        let sum = 0;
        Object.assign(obj, { [shiftLabel]: s.shiftName });
        s.drillActivityProductionDetail.forEach((activity, index) => {
          Object.assign(obj, { [activity.drillActivityName]: activity.drillActivityCount });
          sum += activity.drillActivityCount;
          totalActivity[index] += activity.drillActivityCount;

          if (s.drillActivityProductionDetail.length - 1 === index) {
            totalActivity[index + 1] += sum;
          }
        });

        Object.assign(obj, { total: sum });
        mappedActivity.push({ [shiftLabel]: obj.shiftName, total: obj.total, ...obj });
      });

      const totalRow: any = {};
      totalActivity = [this.langService.message('total').toUpperCase(), ...totalActivity];
      totalActivity = [
        totalActivity[0],
        totalActivity[totalActivity.length - 1],
        ...totalActivity.slice(1, totalActivity.length - 1),
        totalActivity[1],
      ];
      Object.keys(mappedActivity[0]).forEach((value, index) => {
        Object.assign(totalRow, { [value]: totalActivity[index] });
      });
      mappedActivity.push({ [shiftLabel]: totalRow.shiftName, total: totalRow.total, ...totalRow });
    } else {
      this.displayMessage = true;
    }

    this.setTableConfig(mappedActivity);
  }

  /**
   *
   * Set table config
   */
  public setTableConfig(tableData: any): void {
    const shiftLabel = this.langService.message('shiftName');

    const extraParams: ITableExtraParams = {
      disableFooter: true,
    };
    const headerParams: ITableHeaderParams = {
      data: tableData,
      translatable: false,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      colorConfig: [
        { field: shiftLabel, isBold: true },
        { field: 'total', isBold: true },
      ],
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset, extraParams }), 0);
  }
}
